import {useTranslation} from 'react-i18next';
import {usePriceSuggestion} from '@/api/hooks';
import {formatUnitPrice,unitPriceToInput} from '@/domain/money';

/**
 * Gợi ý giá theo bậc số lượng, ngay cạnh ô số lượng của dòng hàng.
 *
 * KHÔNG tự ghi đè đơn giá. Người lập chứng từ có thể vừa thỏa thuận một giá
 * riêng qua điện thoại rồi gõ tay vào; tự đổi nó khi họ chỉnh số lượng là âm
 * thầm sửa tiền sau lưng người dùng — thứ hệ này cấm ở mọi chỗ khác. Bấm vào
 * gợi ý thì mới áp.
 *
 * Không hiện gì khi chưa có số lượng, hoặc khi giá đang nhập ĐÃ đúng bằng gợi ý.
 *
 * Gợi ý ở tiền tệ KHÁC chứng từ thì không hiện (yêu cầu v1.8 mục 6.2, 11/10/2026): trước đây PI RMB vẫn hiện "$0.2690 · giá dưới
 * MOQ" và bấm vào là đặt nguyên con số USD làm giá RMB — đúng điều khách cấm ("do not simply relabel the unchanged number"). Đổi
 * tiền tệ đi qua ô "Quy đổi đơn giá" của hộp Thêm sản phẩm, có tỷ giá rõ ràng. Ô đơn giá nhận số trần, nên áp số không kèm ký hiệu.
 */
export function TierPriceHint({productId,customerId,quantity,unit,unitPrice,currency,onApply}:{
 productId:string;customerId?:string;quantity:string;unit?:string;unitPrice:string;
 /** Tiền tệ của chứng từ — gợi ý ở tiền tệ khác bị bỏ. */
 currency:string;
 onApply:(price:string)=>void;
}){
 const {t}=useTranslation();
 const qty=Number(quantity);
 const enabled=Number.isFinite(qty)&&qty>0;
 const q=usePriceSuggestion(productId,{customerId,quantity:enabled?qty:undefined,unit},enabled);
 const s=q.data;
 if(!enabled||!s||s.price==null)return null;
 if(s.currency!==currency)return null;
 // Giá gợi ý tính theo ĐƠN VỊ GỐC của sản phẩm. Dòng bán theo đơn vị khác (máy chủ phải quy đổi số lượng để tìm bậc) thì con số
 // này không phải đơn giá của dòng — áp vào là đặt giá một gross cho một chiếc (×144). Giá theo đơn vị đi qua ô "Đơn vị & giá".
 if(s.converted)return null;
 // Chưa có hồ sơ quy đổi thì máy chủ không "converted" — vẫn phải so đơn vị của dòng với đơn vị gốc của con số giá.
 if(unit?.trim()&&s.productUnit?.trim()&&unit.trim().toLowerCase()!==s.productUnit.trim().toLowerCase())return null;
 const suggested=unitPriceToInput(s.price);
 if(suggested===unitPrice.trim())return null;
 const label=s.source==='tier'?t('priceTiers.hintTier',{from:s.tierFrom})
  :s.source==='underMoq'?t('priceTiers.hintUnderMoq')
  :s.source==='customer'?t('priceTiers.hintCustomer'):null;
 if(!label)return null;
 return <button type="button" className="mt-0.5 block text-2xs text-brand underline"
   title={t('priceTiers.hintApply')}
   onClick={()=>onApply(suggested)}>
  {formatUnitPrice(s.price,s.currency)} · {label}
 </button>;
}
